import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from './CookieConsent';
import BackToTop from './BackToTop';
import { useThemeStore } from '@/shared/stores/themeStore';

export default function Layout() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    document.body.classList.toggle('site-light', theme === 'light');
    return () => document.body.classList.remove('site-light');
  }, [theme]);

  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:text-sm focus:font-mono"
        style={{ backgroundColor: 'var(--color-accent)', color: 'var(--color-background)' }}
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="flex-1 pt-3">
        <div className="container-wide">
          <Outlet />
        </div>
      </main>
      <Footer />
      <CookieConsent />
      <BackToTop />
    </div>
  );
}
